import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Button from '../../../Common/Button';
import Icon from '../../../Common/Icon';
import InputText from '../../../FormFields/Text';

import {ReactComponent as InfoIcon} from '../../../../../img/icon-info.svg';
import {ReactComponent as CloseIcon} from '../../../../../img/dialog-close.svg';

import ConfigService from '../../../../Services/api/Config';

const CloneSectionModal = ({
  isOpen,
  value,
  lockLabel,
  onCancel,
  onConfirm,
  onChangeText,
  error,
  onErrorText,
  textValidator
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      contentLabel='Clone Section'
      className='Modal_Content'
      overlayClassName='Modal_Overlay'
    >
      <div className='Modal_Content_Container Center'>
        <h2>Clone Section Form</h2>
        <div className='Modal_Content_Warning' style={ { color: ConfigService.getColor('warningColor') } }>
          <Icon className='Icon-Warning' width='16' height='16' color='warningColor'>
            <InfoIcon alt='icon-info'/>
          </Icon>
          Are you sure you want to clone this section?
        </div>
        {lockLabel &&
          <div className="Align_Left Section_Label">
            New Section Label:
            <span>{value}</span>
          </div>
        ||
          <InputText required value={value}
                     onChange={onChangeText} error={error}
                     onError={onErrorText}
                     validators={[textValidator]}/>
        }
        <div className='Modal_Content_Actions Center'>
          <Button className='Button_Small Inline' onClick={onConfirm}>
            Yes
          </Button>
          <Button className='Button_Small Button_Cancel Inline' onClick={onCancel}>
            Cancel
          </Button>
        </div>
        <div className='Modal_Content_Close' onClick={onCancel}>
          <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
            <CloseIcon alt='icon-close'/>
          </Icon>
        </div>
      </div>
    </Modal>
  )
}

CloneSectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onChangeText: PropTypes.func.isRequired,
  onErrorText: PropTypes.func.isRequired,
  error: PropTypes.string,
  textValidator: PropTypes.func,
}

export default CloneSectionModal;
